// extracted by mini-css-extract-plugin
export default {"form-error-message":"FormErrorMessage_form-error-message__1EHlX","form-error-message__inner":"FormErrorMessage_form-error-message__inner__1NXSk"};